module.exports = __webpack_public_path__ + "img/avatar.1b8be325.svg";